<template>
  <div v-if="this.uiVersion == 3" class="mobile-scroller">
    <div class="mobile-scroller__wrapper">
      <div class="row flex-nowrap flex-lg-wrap blog__row">
        <BlogPost
          v-for="blogPost in this.blogPosts"
          :post="blogPost"
          :key="blogPost.guid"
        />
      </div>
    </div>
  </div>
  <div v-else-if="this.uiVersion == 2" class="row blogposts">
    <BlogPost
      v-for="blogPost in this.blogPosts"
      :post="blogPost"
      :key="blogPost.guid"
    />
  </div>
</template>

<script>
import BlogPost from "./BlogPost.vue";
import axios from "axios";
import xml from "fast-xml-parser";
export default {
  components: {
    BlogPost,
  },

  data() {
    return {
      blogPosts: [],
    };
  },
  mounted: function () {
    this.fetchBlogPosts();
  },
  methods: {
    fetchBlogPosts: function () {
      axios
        .get("https://blog.roll20.net/index.xml")
        .then((result) => {
          let parsedXml = xml.parse(result.data);
          this.blogPosts = parsedXml.rss.channel.item.slice(0, 3);
        });
    },
  },
};
</script>